import React, { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getSelectedDepartmentId,
  getAllDepartmentList,
  getBreakTypeList,
  getShiftTimeMaster,
  getClientid,
  getUserInfo,
  getUserList,
  getMenuList,
} from "redux/selectors";

import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,
} from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  differenceBetweenTwoTime,
  generateHourMinutesFromMinutes,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  addMonthinDate,
} from "utils/Date";
import COLORS from "common/Colors";
import { includes, reduce, concat, find, get, uniqBy } from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";

const StyledTable = styled(Table)`
  padding-top: 20px;
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
    margin-right: 10px;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector,
  .ant-picker,
  .ant-select,
  .ant-select-dropdown,
  .ant-select-dropdown-menu-item,
  .ant-select-dropdown-menu-item-group {
    width: 200px !important;
  }
  .ant-btn.ant-btn-default.ant-dropdown-trigger.w-100.mb-3.custom-filter-btn {
    width: 180px !important;
  }
`;
const StyledButton = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media(max-width:900px){
margin-left:-20px !important;}
  @media (max-width: 768px) {
    margin-left: -20px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
const StyledDropdownCheckBox = styled(DropdownCheckBox)`
  width: 300px;
`;

function BreakReport({
  userRoleId,
  breakTypeList,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userList,
  userInfo,
  menuList, // Added menuList
}) {
  const [leaveList, setLeaveList] = useState([]);
  const [CSVLeaveList, setCSVLeaveList] = useState([]);
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [form] = Form.useForm();
  const csvLinkEl = useRef();
  const [filterList, setFilterList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);
  const curr_month = moment().month() + 1;
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [selectedBreakTypes, setSelectedBreakTypes] = useState([]);
  const [employeeFilterList, setEmployeeFilterList] = useState([]);
  const [breakTypeFilterList, setBreakTypeFilterList] = useState([]);
  const [filteredBreakTypeList, setFilteredBreakTypeList] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [countryFilterList, setCountryFilterList] = useState([]);
  const [getFilterData, setGetFilterData] = useState([]);
  const [filteredUserIds, setFilteredUserIds] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };

  const STAFF_LIST_ALL = leaveList.map((val) => {
    return { user_id: val.userid, name: val.fullname };
  });

  for (let i = 0; i < STAFF_LIST_ALL.length; i++) {
    filterList.push(STAFF_LIST_ALL[i]);
  }

  const STAFF_LIST = [...new Set(filterList.map((a) => JSON.stringify(a)))].map(
    (a) => JSON.parse(a)
  );

  const filterbreaklist = leaveList.filter((val) => {
    if (form.getFieldValue("staff_name") === "") {
      return val;
    } else if (val?.userid === form.getFieldValue("staff_name")) {
      return val;
    }
  });
  const countryList = userList
    .filter((user) =>
      leaveList.some((attendance) => attendance.userid === user.userid)
    )
    .map((user) => user.nationality);
  const CSVHeaders = [
    { label: "Name", key: "fullName" },
    { label: "Department", key: "departmentName" },
    { label: "Date", key: "breakStartDate" },
    { label: "Start time", key: "breakStartDateTime" },
    { label: "End time", key: "breakEndDateTime" },
    { label: "Duration", key: "duration" },
    { label: "Break Type", key: "breakType" },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: "12%",
    },
    {
      title: "Department",
      dataIndex: "departmentname",
      key: "departmentname",
      width: "10%",
    },
    {
      title: "Date",
      dataIndex: "breakstartdate",
      key: "breakstartdate",
      width: "7%",
      render: (date) => {
        const dateFormat = moment(date).format("DD MMM YYYY");
        return `${dateFormat}`;
      },
    },
    {
      title: "Day",
      dataIndex: "breakstartdate",
      key: "breakstartdate",
      width: "10%",
      render: (date) => {
        const getdayAlone = moment(date).format("dddd");
        return `${getdayAlone}`;
      },
    },
    {
      title: "Start time",
      dataIndex: "breakstarttime",
      key: "breakstarttime",
      width: "5%",
    },
    {
      title: "End time",
      dataIndex: "breakendtime",
      key: "breakEndTime",
      width: "5%",
      render: (_, record) => {
        if (record?.breakendtime) {
          return record?.breakendtime;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Duration (in hrs)",
      dataIndex: "duration",
      key: "duration",
      width: "10%",
      render: (_, record) => {
        if (record?.breakendtime) {
          const diff = differenceBetweenTwoTime(
            record?.breakstarttime,
            record?.breakendtime
          );
          return generateHourMinutesFromMinutes(diff);
        } else {
          return "-";
        }
      },
    },
    {
      title: "Break Type",
      dataIndex: "breakid",
      key: "breakid",
      width: "10%",
      render: (breakId) => {
        const breakName = filteredBreakTypeList?.find(
          (item) => item?.breakId === breakId?.toString()
        );
        return breakName ? breakName.breakName : "-";
      },
    },
  ];

  useEffect(() => {
    // Remove "Lunch Break" from breakTypeList
    const filteredBreakTypeList = breakTypeList.filter(
      (item) => item.breakName !== "Lunch Break"
    );
    setFilteredBreakTypeList(filteredBreakTypeList);
    list();
    getBreakReportData();
  }, [
    selectedDepartmentId,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
    form.getFieldValue("break_type"),
    // selectedCountries,
  ]);
  useEffect(() => {
    console.log("leaveList:", leaveList);
    console.log("selectedCountries:", selectedCountries);

    let result;
    if (selectedCountries.length > 0) {
      result = leaveList.filter((data) =>
        selectedCountries.includes(data.nationality)
      );
    } else {
      result = leaveList;
    }
    setCountryFilterList(result);
  }, [selectedCountries, leaveList]);
  useEffect(() => {
    var result;

    if (selectedStaff.length === 0) {
      result = leaveList;
    } else {
      result = leaveList?.filter((data) =>
        selectedStaff.includes(data?.userid)
      );
    }

    setEmployeeFilterList(result);
  }, [leaveList, selectedStaff]);

  useEffect(() => {
    var result;

    if (selectedBreakTypes.length === 0) {
      result = employeeFilterList;
    } else {
      result = employeeFilterList?.filter((data) =>
        selectedBreakTypes.includes(data?.breakid)
      );
    }

    setBreakTypeFilterList(result);
  }, [employeeFilterList, selectedBreakTypes]);

  useEffect(() => {
    let result;
    if (selectedCountries && selectedCountries.length > 0) {
      result = leaveList?.filter((data) =>
        selectedCountries.includes(data?.nationality)
      );
    } else {
      result = leaveList;
    }
    setCountryFilterList(result);
  }, [selectedCountries, leaveList]);

  // filepath: /d:/Wailaworkspace/tymeplushr-system-ui-pheonix/src/pages/BreakReport.js
  const handleEmployeeFilterChange = () => {
    const values = form.getFieldsValue();
    const selectedStaff = values.staff_name || [];
    setSelectedStaff(selectedStaff);

    if (selectedStaff.length === 0) {
      // Reset to full list if no staff is selected
      setEmployeeFilterList(leaveList);
    } else {
      // Filter leaveList locally
      const filteredList = leaveList.filter((data) =>
        selectedStaff.includes(data.userid)
      );
      setEmployeeFilterList(filteredList);
    }
  };
  const handleBreakTypeFilterChange = () => {
    const values = form.getFieldsValue();
    setSelectedBreakTypes(values.break_type || []);
  };

  const handleCountryFilterChange = () => {
    const values = form.getFieldsValue();
    setSelectedCountries(values.country || []);
  };
  console.log("userList--->", userList);
  useEffect(() => {
    console.log("filteredCountries-->", filteredCountries);
    if (filteredCountries.length === 0) {
      setFilteredUserIds([]); // Reset if no filter is selected
      return;
    }

    const filteredUsers = userList.filter((user) => {
      return filteredCountries.some((country) => user.nationality === country);
    });

    const userIds =
      filteredUsers.map((user) => user.userid || user.userId) || [];
    setFilteredUserIds(userIds);
    setGetFilterData(filteredUsers);
    console.log("UserIDs:", userIds);
    console.log("filteredUsers:", filteredUsers);
  }, [filteredCountries]);
  console.log("filteredUserIds--->", filteredUserIds);
  // API Call (Ensure it happens after filteredUserIds updates)
  useEffect(() => {
    if (filteredUserIds.length > 0) {
      getBreakReportData();
    }
  }, [filteredUserIds]);
  const isChairman = userInfo.higherOfficialsList.some(
    (official) => official.role === "CHAIRMAN" && official.email === userInfo.userid
  );
  const getBreakReportData = async () => {
    setLeaveList([]);
    const { start_date, end_date, duration_type, month, break_type } =
      form.getFieldsValue();
    setDisplayTableLoader(true);
    const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
      dateInDetail(getKenyanDateTime()).year,
      get(find(MONTH_LIST, { value: month }), "index", 0)
    );
    const emailList = userInfo.higherOfficialsList.map((official) =>
      official.email.toLowerCase()
    );

    const isPrivilegedUser = emailList.includes(userInfo.userid.toLowerCase());
    const payload = {
      department: [],
      //selectedDepartmentId,
      break_type: break_type ? break_type : "",
      start_date: getMySqlDate(
        duration_type === 2 ? startDateOfMonth : start_date
      ),
      end_date: getMySqlDate(duration_type === 2 ? lastDateOfMonth : end_date),
      reportingmanager:
        isChairman
          ? ""
          : isPrivilegedUser
            ? ""
            : userInfo?.userid,
      userIds:
        isChairman
          ? []
          : isPrivilegedUser
            ? userId
            : filteredUserIds,
    };

    const { code, breakList = [] } = await CALL_API(
      `break-report/${ClientId}`,
      "post",
      payload
    );
    setDisplayTableLoader(false);
    if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
      const updatedLeaveList = breakList?.map((val) => {
        const findUser = find(userList, { userid: val?.userid });
        return {
          ...val,
          nationality: findUser?.nationality,
        };
      });
      setLeaveList(updatedLeaveList.reverse());
    }
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
    getBreakReportData();
  };

  const prepareCSV = async (event, done) => {
    if (filterbreaklist.length > 0) {
      setCSVLeaveList(
        reduce(
          filterbreaklist,
          function (result, BreakReport) {
            const {
              date_th: startDate_th,
              shortMonthName: startMonthName,
              year: end_year,
            } = dateInDetail(BreakReport.breakstartdate);
            const diff = differenceBetweenTwoTime(
              BreakReport.breakstarttime,
              BreakReport.breakendtime
            );
            const hours = Math.floor(diff / 60);
            const minutes = diff - 60 * hours;

            const breakName = filteredBreakTypeList?.find(
              (item) => item?.breakId === BreakReport?.breakid?.toString()
            );
            result.push({
              Name: BreakReport.fullname,
              Department: BreakReport.departmentname,
              Date: `${startDate_th} ${startMonthName} ${end_year}`,
              Day: `${moment(BreakReport.breakstartdate).format("dddd")}`,
              "Start time": BreakReport.breakstarttime,
              "End time": BreakReport.breakendtime,
              Duration: `${hours}:${minutes}`,
              "Break Type": breakName ? breakName.breakName : "-",
            });
            return result;
          },
          []
        )
      );

      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(`No data available to download.`);
    }
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const uniqueEmployeeName = uniqBy(
    STAFF_LIST?.map((item) => {
      return {
        label: item.name,
        value: item.user_id,
      };
    }),
    "value"
  );

  const uniqueBreakTypeName = uniqBy(
    filteredBreakTypeList?.map((item) => {
      return {
        label: item.breakName,
        value: item.breakId,
      };
    }),
    "value"
  );

  const uniqueCountryName = uniqBy(
    userList
      .filter((user) =>
        leaveList.some((checkin) => checkin.userid === user.userid)
      )
      .map((user) => ({
        label: user.nationality,
        value: user.nationality,
      })),
    "value"
  );

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0]; // Added Menulist logic

  const finduser = userList?.find((val) => val?.userid === userInfo?.userid);
  const nationality = finduser?.nationality;
  const userId = userList
    .filter((user) => user.nationality?.includes(nationality))
    .map((user) => user.userid);
  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: [],
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                department: "",
                break_type: [],
                country: [],
              }}
              onFinish={getBreakReportData}
              onValuesChange={(changedValues) => {
                handleEmployeeFilterChange();
                handleBreakTypeFilterChange();
                handleCountryFilterChange();
                if (changedValues) {
                  console.log("changedValues--->", changedValues);
                  getBreakReportData();
                }
              }}
            >
              <Form.Item
                name="duration_type"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  className="custom_form_design"
                  placeholder="Select..."
                  options={REPORT_DURATION_TYPES}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          style={{ borderRadius: "20px" }}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          style={{ borderRadius: "20px" }}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      name="month"
                      rules={[
                        {
                          required: true,
                          message: "",
                        },
                      ]}
                    >
                      <Select
                        className="custom_form_design"
                        placeholder="Select..."
                        options={monthList}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <DropdownCheckBox
                  name="staff_name"
                  label="Employee"
                  options={uniqueEmployeeName}
                  form={form}
                  handleFormChange={handleEmployeeFilterChange}
                  style={{ width: "300px" }}
                />
              </Form.Item>

              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}

              <Form.Item name="break_type">
                <DropdownCheckBox
                  name="break_type"
                  label="Break Type"
                  options={uniqueBreakTypeName}
                  form={form}
                  handleFormChange={handleBreakTypeFilterChange}
                  style={{ width: "300px" }}
                />
              </Form.Item>
              {console.log("userid", userInfo.userid)}
              {
                // Menulist?.find(
                //   (item) =>
                //     item?.key === "countryfilter" &&
                //     item?.permission?.view
                // ) ||
                isChairman && (
                  <Form.Item name="country">
                    <DropdownCheckBox
                      name="country"
                      label="Country"
                      options={uniqueCountryName}
                      form={form}
                      clearFunction={getBreakReportData}
                      handleFormChange={handleCountryFilterChange}
                      style={{ width: "300px" }}
                    />
                  </Form.Item>
                )
              }
            </StyledSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <StyledButtonoutlined
            onClick={prepareCSV}
            disabled={leaveList.length === 0}
          >
            Export CSV file
          </StyledButtonoutlined>
          <CSVLink
            header={CSVHeaders}
            data={CSVLeaveList}
            filename={"Break-report.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </Col>
      </Row>
      <br />
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={
            selectedCountries.length > 0
              ? countryFilterList
              : employeeFilterList.length > 0
                ? employeeFilterList
                : leaveList
          }
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="user_leave_id"
          pagination={leaveList.length > 100 ? paginationOptions : false}
        />
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userList: getUserList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  allDepartmentList: getAllDepartmentList(state),
  breakTypeList: getBreakTypeList(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  menuList: getMenuList(state), // Added menuList
});

export default connect(mapStateToProps, null)(BreakReport);
